/* PR 58 / 59 FIXES · F6 (agent D) — dashboard links: Engagements ?stage= filter and Risk register ?head= filter. EN + AR.
   Registered at the end of lib/i18n.js (one import + two _overrideDeep lines). */
export const I18N_FX_D = {
  en: {
    fxD: {
      stageFilter: {
        chip: "Status: {stage}",
        clear: "Clear the status filter",
        empty: "No engagements at this stage",
        loading: "Checking the status of {n} engagement(s)…",
      },
      headFilter: {
        chip: "FS head: {code} {name}",
        clear: "Clear the FS head filter",
        empty: "No risks linked to this FS head",
      },
    },
  },
  ar: {
    fxD: {
      stageFilter: {
        chip: "الحالة: {stage}",
        clear: "إزالة تصفية الحالة",
        empty: "لا توجد ارتباطات في هذه المرحلة",
        loading: "جارٍ التحقق من حالة {n} ارتباط…",
      },
      headFilter: {
        chip: "بند القوائم المالية: {code} {name}",
        clear: "إزالة تصفية بند القوائم المالية",
        empty: "لا توجد مخاطر مرتبطة بهذا البند",
      },
    },
  },
};

export default I18N_FX_D;
